<h2 mat-dialog-title> Sélectionner la période pour EvalTV</h2>
<mat-dialog-content class="layout-row align-center-center gap-10" [formGroup]="groupDate">
  <mat-form-field appearance="fill">
    <mat-label>Du</mat-label>
    <input matInput formControlName="start" [min]="min" [max]="max" [matDatepicker]="pickerStart">
    <mat-hint>DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
    <mat-datepicker #pickerStart></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="fill" >
    <mat-label>Au</mat-label>
    <input matInput formControlName="end" [min]="min" [max]="max" [matDatepicker]="pickerEnd">
    <mat-hint>DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
    <mat-datepicker #pickerEnd></mat-datepicker>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="layout-row align-center-center">
  <button mat-button
          class="reject-button"
          (click)="close()">
    Annuler
  </button>
  <button mat-button
          class="accept-button"
          (click)="validation()"
          [disabled]="groupDate.get('start').invalid || groupDate.get('end').invalid">
    Valider
  </button>
</mat-dialog-actions>
